export default __webpack_public_path__ + "static/media/ge.81e24f42.jpg";